<template>
  <div class="l-notsupport">
    <small>当前设备信息：<br />{{ ua }}</small>
  </div>
</template>

<script>
import version from "@/utils/version";

export default {
  data () {
    return {
      message: "",
      ua: navigator.userAgent,
    };
  },
  created () {
    const ispc = version.isPC();
    const ischrome = version.isChrome();
    const chromeVersion = version.chromeVersion();

    if (ispc && ischrome && chromeVersion) {
      window.location.href = window.location.origin;
      return;
    }

    if (ispc && !chromeVersion) {
      this.$lPrompt({
        message: "当前浏览器版本过低，影响使用，请升级浏览器版本～;如果您现在使用的是移动设备，请将浏览器设置中的“请求电脑桌面版”关闭后刷新页面",
        successTxt: "知道了",
        successFn: () => {
          window.location.href = this.href;
        },
      });
      return;
    }
    this.message = !ispc
      ? "为了确保良好闯关体验，请下载LILY讲故事APP进入闯关"
      : !ischrome
        ? "为了确保良好闯关体验，请您使用谷歌Chrome浏览器进入闯关"
        : "";
    this.href = !ispc
      ? "https://a.app.qq.com/o/simple.jsp?pkgname=com.lilyenglish.lilyenglish"
      : !ischrome
        ? "https://www.baidu.com/s?ie=UTF-8&wd=chrome"
        : "";

    this.$lPrompt({
      message: this.message,
      successTxt: "去下载",
      successFn: () => {
        window.location.href = this.href;
      },
    });

    if (!ispc) {
      setTimeout(() => {
        document.querySelector(".l-dialog").style.zoom = 0.6;
      }, 20);
    }
  },
};
</script>

<style lang="stylus" scope>
.l-dialog
  top 30%
  transform translate(0, -50%)
  // zoom: 0.7
.l-notsupport
  font-size 14px
  width 100vw
  height 100vh
  display flex
  flex-direction column
  justify-content center
  align-items center
  padding 20px
  box-sizing border-box
</style>
